var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperienceWizardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95833 0.375C1.07958 0.375 0.375 1.07958 0.375 1.95833V13.0417C0.375 13.4616 0.541815 13.8643 0.838748 14.1613C1.13568 14.4582 1.53841 14.625 1.95833 14.625H13.0417C13.4616 14.625 13.8643 14.4582 14.1613 14.1613C14.4582 13.8643 14.625 13.4616 14.625 13.0417V7.5H13.0417V13.0417H1.95833V1.95833H7.5V0.375H1.95833ZM12.0758 1.16667C11.9413 1.16667 11.7987 1.22208 11.6958 1.325L10.73 2.28292L12.7092 4.26208L13.675 3.30417C13.8808 3.09833 13.8808 2.75 13.675 2.55208L12.4479 1.325C12.345 1.22208 12.2104 1.16667 12.0758 1.16667ZM10.1679 2.845L4.33333 8.6875V10.6667H6.3125L12.1471 4.82417L10.1679 2.845Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceWizardIcon);
export default __webpack_public_path__ + "static/media/experience-wizard-icon.4f89930c.svg";
export { ForwardRef as ReactComponent };